/* FGO store finder (24 Sep 2026). See sections/fgo-store-finder.liquid for why this
   exists. The stores, a US Census ZIP table and a US Census places table are theme
   assets (the two tables are split into small files and only the one a search needs is
   loaded). The street map is MapLibre GL from jsDelivr (pinned + integrity-checked) on
   OpenFreeMap tiles (no key, no account); if either is unavailable the page keeps a dot
   map drawn from the stores' own coordinates. Search needs no outside service. */
(function () {
  'use strict';
  var STATES = { al: 'alabama', ak: 'alaska', az: 'arizona', ar: 'arkansas', ca: 'california', co: 'colorado', ct: 'connecticut', de: 'delaware', dc: 'district of columbia',
    fl: 'florida', ga: 'georgia', hi: 'hawaii', id: 'idaho', il: 'illinois', 'in': 'indiana', ia: 'iowa', ks: 'kansas', ky: 'kentucky', la: 'louisiana', me: 'maine', md: 'maryland',
    ma: 'massachusetts', mi: 'michigan', mn: 'minnesota', ms: 'mississippi', mo: 'missouri', mt: 'montana', ne: 'nebraska', nv: 'nevada', nh: 'new hampshire', nj: 'new jersey',
    nm: 'new mexico', ny: 'new york', nc: 'north carolina', nd: 'north dakota', oh: 'ohio', ok: 'oklahoma', or: 'oregon', pa: 'pennsylvania', ri: 'rhode island', sc: 'south carolina',
    sd: 'south dakota', tn: 'tennessee', tx: 'texas', ut: 'utah', vt: 'vermont', va: 'virginia', wa: 'washington', wv: 'west virginia', wi: 'wisconsin', wy: 'wyoming', pr: 'puerto rico' };
  var BY_NAME = {}; Object.keys(STATES).forEach(function (k) { BY_NAME[STATES[k]] = k; });
  /* state names that are also big cities: offer both */
  var BOTH = { 'new york': 'ny', 'washington': 'dc', 'los angeles': 'ca' };

  /* the same normalisation the data build uses (pdp/store-locator/build_data.py) */
  function norm(t) {
    t = String(t || '').toLowerCase().trim();
    t = t.replace(/\bsaint\s/g, 'st ').replace(/\bst\.\s/g, 'st ').replace(/\bmount\s/g, 'mt ').replace(/\bfort\s/g, 'ft ');
    t = t.replace(/[.'`’]/g, '').replace(/[^a-z0-9 ]+/g, ' ');
    return t.replace(/\s+/g, ' ').trim();
  }
  function miles(a, b, c, d) {
    var r = Math.PI / 180, dl = (c - a) * r, dn = (d - b) * r;
    var h = Math.sin(dl / 2) * Math.sin(dl / 2) + Math.cos(a * r) * Math.cos(c * r) * Math.sin(dn / 2) * Math.sin(dn / 2);
    return 3958.8 * 2 * Math.asin(Math.min(1, Math.sqrt(h)));
  }
  function getJSON(url) { return fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function title(s) { return String(s).replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }); }
  /* undo the search shorthand for display */
  function pretty(s) { return title(s).replace(/\bSt(?= )/g, 'St.').replace(/\bMt(?= )/g, 'Mount').replace(/\bFt(?= )/g, 'Fort'); }
  function letter(name) { var c = name.charAt(0); return /[a-z]/.test(c) ? c : '0'; }
  function mi(d) { return d < 1 ? 'Under 1' : d < 10 ? d.toFixed(1) : String(Math.round(d)); }

  var APPLE = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var mq = function (q) { return !!(window.matchMedia && matchMedia(q).matches); };
  var REDUCED = mq('(prefers-reduced-motion: reduce)');
  /* Shopify custom events, for a web pixel to pass on to GA4. Never a location, at most ZIP3 or a state. */
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }

  /* ---- a US map projection for the dot map (Albers equal-area, Alaska and Hawaii insets) ---- */
  function albers(p1, p2, p0, l0) {
    var r = Math.PI / 180, s1 = Math.sin(p1 * r), s2 = Math.sin(p2 * r), n = (s1 + s2) / 2;
    var C = Math.cos(p1 * r) * Math.cos(p1 * r) + 2 * n * s1, r0 = Math.sqrt(C - 2 * n * Math.sin(p0 * r)) / n;
    return function (lat, lng) {
      var rho = Math.sqrt(Math.max(0, C - 2 * n * Math.sin(lat * r))) / n, th = n * (lng - l0) * r;
      return [rho * Math.sin(th), -(r0 - rho * Math.cos(th))];
    };
  }
  var P48 = albers(29.5, 45.5, 37.5, -96), PAK = albers(55, 65, 50, -154), PHI = albers(8, 18, 3, -157);
  var W = 960, H = 600;
  function fitter(pr, box, ext) {
    var a = pr(ext[0], ext[1]), b = pr(ext[2], ext[3]), c = pr(ext[0], ext[3]), d = pr(ext[2], ext[1]);
    var x0 = Math.min(a[0], b[0], c[0], d[0]), x1 = Math.max(a[0], b[0], c[0], d[0]), y0 = Math.min(a[1], b[1], c[1], d[1]), y1 = Math.max(a[1], b[1], c[1], d[1]);
    var k = Math.min((box[2] - box[0]) / (x1 - x0), (box[3] - box[1]) / (y1 - y0));
    return function (lat, lng) { var q = pr(lat, lng); return [box[0] + (q[0] - x0) * k, box[1] + (y1 - q[1]) * k * -1 + (y1 - y0) * k]; };
  }
  var F48 = fitter(P48, [40, 30, 920, 520], [24.4, -124.8, 49.4, -66.9]);
  var FAK = fitter(PAK, [30, 440, 200, 580], [51.2, -170, 71.4, -129.9]);
  var FHI = fitter(PHI, [215, 500, 320, 580], [18.9, -160.3, 22.3, -154.8]);
  function proj(lat, lng) {
    if (lat > 50 && lng < -129) return FAK(lat, lng);
    if (lat < 23.5 && lng < -154) return FHI(lat, lng);
    return F48(lat, lng);
  }

  function init(root) {
    var $ = function (s) { return root.querySelector(s); };
    var form = $('[data-sf-form]'), input = $('[data-sf-q]'), result = $('[data-sf-result]'), sum = $('[data-sf-sum]'), sub = $('[data-sf-sub]');
    var live = $('[data-sf-live]'), list = $('[data-sf-list]'), chips = $('[data-sf-chips]'), more = $('[data-sf-more]'), near = $('[data-sf-near]'), mapBox = $('[data-sf-map]');
    var files = {}; try { files = JSON.parse($('[data-sf-files]').textContent); } catch (e) {}
    var radius = parseFloat(root.getAttribute('data-sf-radius')) || 100;
    var shopUrl = root.getAttribute('data-sf-shop') || '/collections/all';
    var stores = null, storesP = null, cache = {};
    var shown = [], total = 0, page = 0, origin = null, seq = 0, lastV = null;
    /* Walmart's list says which of our teas each store carries (a bit per tea) */
    var ITEMS = [], ASOF = '', tea = -1, again = null;
    var teaSel = $('[data-sf-tea]'), teaWrap = $('[data-sf-teawrap]');
    var slug = function (n) { return String(n).toLowerCase().replace(/[^a-z0-9]+/g, '-'); };
    var teaName = function () { return tea >= 0 ? ITEMS[tea] : ''; };

    function say(main, extra) {
      sum.innerHTML = main || ''; sub.innerHTML = extra || '';
      result.hidden = !main;
      /* screen readers hear the answer from an always-present live region */
      if (live) live.textContent = (sum.textContent + ' ' + sub.textContent).replace(/\s+/g, ' ').trim();
    }
    var deliver = function () { return 'Or <a href="' + esc(shopUrl) + '" data-sf-shop>buy direct from us</a> and save 15% when you subscribe.'; };
    var deliverBlock = function () {
      return '<span class="sf-dtc-mini"><b>Get it delivered instead.</b> Save 15% when you subscribe, and get free shipping on orders over $50.' +
        '<a class="sf-dtc-btn" href="' + esc(shopUrl) + '" data-sf-shop>Shop all products</a></span>';
    };

    /* ---- data ---- */
    function loadStores() {
      if (!storesP) {
        storesP = getJSON(root.getAttribute('data-sf-stores')).then(function (d) {
          var rows = Array.isArray(d) ? d : d.s;
          ITEMS = (d && d.items) || []; ASOF = (d && d.asof) || '';
          stores = rows.map(function (s, i) { return { i: i, lat: s[0], lng: s[1], address: s[2], city: s[3], state: s[4], zip: String(s[5]), nbr: s[6] || 0, mask: s[7] || 0 }; });
          setupTea();
          drawMap();
          return stores;
        }, function (e) { storesP = null; throw e; });
      }
      return storesP;
    }
    function shard(kind, key) {
      var url = files[kind] && files[kind][key], id = kind + ':' + key;
      if (!url) return Promise.resolve(kind === 'zips' ? { z: '', p: [] } : {});
      if (!cache[id]) cache[id] = getJSON(url).catch(function (e) { delete cache[id]; throw e; });
      return cache[id];
    }
    function zipPoint(z, zd) {
      var i = zd.z.indexOf(z);
      while (i !== -1 && i % 5 !== 0) i = zd.z.indexOf(z, i + 1);
      if (i !== -1) { i = i / 5; return { lat: zd.p[2 * i] / 1000, lng: zd.p[2 * i + 1] / 1000, approx: false }; }
      /* a ZIP with no Census area (PO boxes, single buildings): use its 3-digit area */
      var pre = z.slice(0, 3), n = 0, la = 0, lo = 0;
      for (var j = 0; j < zd.z.length; j += 5) {
        if (zd.z.substr(j, 3) === pre) { la += zd.p[2 * (j / 5)]; lo += zd.p[2 * (j / 5) + 1]; n++; }
      }
      return n ? { lat: la / n / 1000, lng: lo / n / 1000, approx: true } : null;
    }

    /* ---- parsing what someone typed or pasted ---- */
    function parse(q) {
      var raw = String(q || '').trim();
      if (!raw) return null;
      /* a ZIP anywhere ("3803 Osborne Dr W, Hastings, NE 68901"), unless it is a house number */
      var re = /\b(\d{5})(?:-\d{4})?\b/g, m, last = null;
      while ((m = re.exec(raw))) last = m;
      if (last && !(last.index === 0 && raw.slice(last[0].length).trim())) return { zip: last[1] };
      /* drop street segments: "3803 Osborne Dr W, Hastings, NE" -> "Hastings, NE" */
      var segs = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (segs.length > 1) segs = segs.filter(function (s, i) { return i === segs.length - 1 || !/^\d/.test(s); });
      var t = norm(segs.join(' '));
      if (!t) return null;
      if (t === 'la') return { stateOnly: 'la', both: 'los angeles' };
      if (STATES[t]) return { stateOnly: t };
      if (BY_NAME[t]) return { stateOnly: BY_NAME[t], both: BOTH[t] ? t : null };
      var words = t.split(' '), st = null;
      for (var k = Math.min(3, words.length - 1); k >= 1; k--) {       /* "raleigh north carolina", "denver co" */
        var tail = words.slice(words.length - k).join(' ');
        if (k === 1 && STATES[tail]) { st = tail; words = words.slice(0, -1); break; }
        if (BY_NAME[tail]) { st = BY_NAME[tail]; words = words.slice(0, -k); break; }
      }
      if (!words.length) return st ? { stateOnly: st } : null;
      if (words.length === 1 && words[0] === 'state' && st) return { stateOnly: st };   /* "Washington state" */
      if (words[words.length - 1] === 'state' && words.length > 1 && BY_NAME[words.slice(0, -1).join(' ')]) return { stateOnly: BY_NAME[words.slice(0, -1).join(' ')] };
      return { city: words.join(' '), state: st, words: words };
    }
    /* the names to try, most specific first; "123 main st denver" also tries "denver" */
    function cityTries(p) {
      var c = p.city, out = [c, c.replace(/\s(city|town|village)$/, ''), c.replace(/^the\s/, '')];
      for (var k = Math.min(3, p.words.length - 1); k >= 1; k--) out.push(p.words.slice(-k).join(' '));
      return out.filter(function (x, i) { return x && out.indexOf(x) === i; });
    }

    /* ---- the tea menu ---- */
    /* the tea menu and per-store tea lists are off unless the section's "Tea menu" setting is on */
    var teasOn = root.getAttribute('data-sf-teas') === 'true';
    function setupTea() {
      if (!teasOn || !teaSel || !ITEMS.length) return;
      teaSel.innerHTML = '<option value="">All our teas</option>' + ITEMS.map(function (n) { return '<option value="' + slug(n) + '">' + esc(n) + '</option>'; }).join('');
      var t0 = null; try { t0 = new URL(location.href).searchParams.get('tea'); } catch (e) {}
      var k = t0 ? ITEMS.map(slug).indexOf(t0) : -1;
      if (k >= 0) { tea = k; teaSel.value = t0; }
      teaWrap.hidden = false;
    }
    if (teaSel) teaSel.addEventListener('change', function () {
      var v = teaSel.value; tea = v ? ITEMS.map(slug).indexOf(v) : -1;
      try { var u = new URL(location.href); if (v) u.searchParams.set('tea', v); else u.searchParams.delete('tea'); history.replaceState(null, '', u.toString()); } catch (e) {}
      track('fgo_store_tea', { tea: v || 'all' });
      if (again) again();
    });
    function carries(s) { return tea < 0 || !!(s.mask & (1 << tea)); }
    function teasOf(s) {
      if (!teasOn || !ITEMS.length || !s.mask) return '';
      var have = ITEMS.map(function (n, i) { return (s.mask & (1 << i)) ? i : -1; }).filter(function (i) { return i >= 0; });
      if (have.length === ITEMS.length) return 'All ' + ITEMS.length + ' of our Walmart teas' + (tea >= 0 ? ', including <b>' + esc(ITEMS[tea]) + '</b>' : '');
      return have.map(function (i) { return i === tea ? '<b>' + esc(ITEMS[i]) + '</b>' : esc(ITEMS[i]); }).join(', ');
    }

    /* ---- a near miss: the closest spellings in the town table already loaded ---- */
    function lev(a, b, max) {
      if (Math.abs(a.length - b.length) > max) return max + 1;
      var prev = [], cur, i, j;
      for (j = 0; j <= b.length; j++) prev[j] = j;
      for (i = 1; i <= a.length; i++) {
        cur = [i]; var low = i;
        for (j = 1; j <= b.length; j++) { cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1)); if (cur[j] < low) low = cur[j]; }
        if (low > max) return max + 1;
        prev = cur;
      }
      return prev[b.length];
    }
    function suggest(p, byL) {
      var name = p.city, sh = byL[letter(name)] || {}, out = [];
      if (name.length < 4) return out;
      Object.keys(sh).forEach(function (k) {
        var m = name.length < 7 ? 1 : 2, d = lev(name, k, m); if (d < 1 || d > m) return;
        Object.keys(sh[k]).forEach(function (st) { if (!p.state || st === p.state) out.push({ k: k, st: st, d: d, km: sh[k][st][2] || 0 }); });
      });
      out.sort(function (a, b) { return a.d - b.d || b.km - a.km; });
      return out.slice(0, 4);
    }

    /* ---- the search ---- */
    function reset() {
      chips.hidden = true; chips.innerHTML = '';
      list.innerHTML = ''; more.hidden = true; shown = []; total = 0; page = 0;
    }
    function done() { result.removeAttribute('aria-busy'); }
    function fail(my) { if (my === seq) { done(); say('Search isn’t working right now.', 'Check your connection and try again.'); } }
    function run(q) {
      var my = ++seq;
      reset();
      var p = parse(q);
      if (!p) { say('Type a ZIP code or a city and state.'); return; }
      startGL();
      if (p.stateOnly && p.both) return offerBoth(p, q, my);
      if (p.stateOnly) return stateView(p.stateOnly, q, my);
      say('Finding stores&hellip;'); result.setAttribute('aria-busy', 'true');
      if (p.zip) {
        Promise.all([loadStores(), shard('zips', p.zip.charAt(0))]).then(function (r) {
          if (my !== seq) return;
          var z = zipPoint(p.zip, r[1]);
          if (!z) return notFound(q);
          show({ lat: z.lat, lng: z.lng }, 'ZIP ' + p.zip + (z.approx ? ' (area)' : ''), q, { kind: 'zip', area: p.zip.slice(0, 3) });
        }).catch(function () { fail(my); });
        return;
      }
      var tries = cityTries(p), letters = tries.map(letter).filter(function (x, i, a) { return a.indexOf(x) === i; });
      Promise.all([loadStores()].concat(letters.map(function (l) { return shard('places', l); }))).then(function (r) {
        if (my !== seq) return;
        var byL = {}; letters.forEach(function (l, i) { byL[l] = r[i + 1]; });
        for (var i = 0; i < tries.length; i++) {
          var cands = byL[letter(tries[i])][tries[i]];
          if (!cands) continue;
          if (p.state) {
            if (!cands[p.state]) continue;
            var c = cands[p.state];
            return show({ lat: c[0] / 1000, lng: c[1] / 1000 }, pretty(tries[i]) + ', ' + p.state.toUpperCase(), q, { kind: 'city', area: p.state });
          }
          var sts = Object.keys(cands);
          if (sts.length === 1) { var o = cands[sts[0]]; return show({ lat: o[0] / 1000, lng: o[1] / 1000 }, pretty(tries[i]) + ', ' + sts[0].toUpperCase(), q, { kind: 'city', area: sts[0] }); }
          return which(tries[i], cands, q);
        }
        var sug = suggest(p, byL);
        if (sug.length) return didYouMean(sug, q);
        notFound(q);
      }).catch(function () { fail(my); });
    }
    function setQ(q) {
      if (!window.history || !history.replaceState) return;
      try { var u = new URL(location.href); u.searchParams.delete('q'); if (q) u.searchParams.set('find', q); else u.searchParams.delete('find'); history.replaceState(null, '', u.toString()); } catch (e) {}
    }
    function notFound(q) {
      done(); setView({}); again = null;
      say('We couldn’t find “' + esc(q) + '”.', 'Try a 5-digit ZIP like 68901, or a city and state like Denver, CO.');
      track('fgo_store_search', { kind: 'none', results: 0 });
    }
    function didYouMean(sug, q) {
      done(); setView({}); origin = null; again = null;
      say('Did you mean&hellip;', '');
      chipRow(sug.map(function (o) { var v = pretty(o.k) + ', ' + o.st.toUpperCase(); return { label: v, q: v }; }));
      setQ(q);
      track('fgo_store_search', { kind: 'suggest', results: sug.length });
    }
    function stateView(code, q, my) {
      loadStores().then(function () {
        if (my !== seq) return;
        var name = esc(title(STATES[code])), inSt = stores.filter(function (s) { return s.state.toLowerCase() === code && carries(s); });
        origin = null; setQ(q);
        again = function () { var m2 = ++seq; reset(); stateView(code, q, m2); };
        track('fgo_store_search', { kind: 'state', results: inSt.length, area: code });
        var w = teaName() ? ' with ' + esc(teaName()) : '';
        if (!inSt.length) { say('We don’t have a Walmart' + w + ' in ' + name + ' on our list.', deliverBlock()); setView({}); return; }
        /* the state's busiest areas: the town with the most stores within 25 miles, then the next
           one clear of it, and so on */
        var left = inSt.slice(), areas = [];
        while (areas.length < 6 && left.length) {
          var best = null;
          left.forEach(function (a) {
            var nb = left.filter(function (b) { return miles(a.lat, a.lng, b.lat, b.lng) <= 25; });
            if (!best || nb.length > best.nb.length) best = { s: a, nb: nb };
          });
          if (best.nb.length < 2) break;
          if (!areas.some(function (x) { return x.s.city === best.s.city; })) areas.push(best);
          left = left.filter(function (b) { return best.nb.indexOf(b) < 0; });
        }
        say('<b>' + inSt.length + (inSt.length === 1 ? ' store' : ' stores') + '</b>' + w + ' in ' + name + '.',
          (areas.length > 1 ? 'Pick an area, or add' : 'Add') + ' a city or ZIP code to see the closest.');
        if (areas.length > 1) chipRow(areas.map(function (x) { var v = x.s.city + ', ' + code.toUpperCase(); return { label: v, q: v, note: x.nb.length + ' within 25 mi' }; }));
        setView({ state: inSt, st: code });
      }).catch(function () { fail(my); });
    }
    function chipRow(items) {
      chips.innerHTML = items.map(function (c, i) {
        return '<button type="button" class="sf-chip" data-c="' + i + '">' + esc(c.label) + (c.note ? ' <span>' + esc(c.note) + '</span>' : '') + '</button>';
      }).join('');
      chips.hidden = false;
      [].forEach.call(chips.querySelectorAll('button'), function (b) {
        b.addEventListener('click', function () { var c = items[+b.getAttribute('data-c')]; input.value = c.q; run(c.q); sum.focus(); });
      });
    }
    function offerBoth(p, q, my) {
      loadStores().then(function () {
        if (my !== seq) return;
        var st = p.stateOnly, city = BOTH[p.both];
        say('The city or the state?');
        chipRow([{ label: pretty(p.both) + ', ' + city.toUpperCase(), q: pretty(p.both) + ', ' + city.toUpperCase() },
                 { label: title(STATES[st]) + ' (state)', q: title(STATES[st]) + ' state' }]);
        setView({}); setQ(q);
      }).catch(function () { fail(my); });
    }
    /* several towns share the name: list the ones with stores nearby, biggest first */
    function which(name, cands, q) {
      done(); origin = null; again = null;
      var opts = Object.keys(cands).map(function (st) {
        var lat = cands[st][0] / 1000, lng = cands[st][1] / 1000, n = 0, best = Infinity;
        for (var i = 0; i < stores.length; i++) { var d = miles(lat, lng, stores[i].lat, stores[i].lng); if (d <= radius) n++; if (d < best) best = d; }
        return { st: st, n: n, best: best, km: cands[st][2] || 0 };
      });
      var withStores = opts.filter(function (o) { return o.n > 0; }), pool = withStores.length ? withStores : opts;
      /* biggest town first (land area stands in for size), then most stores */
      pool.sort(function (a, b) { return b.km - a.km || b.n - a.n || a.best - b.best; });
      say('Which ' + esc(pretty(name)) + '?', withStores.length ? 'Store counts are within ' + radius + ' miles.' : 'None of them has a store within ' + radius + ' miles.');
      var pick = pool.slice(0, 8);
      chipRow(pick.map(function (o) { var v = pretty(name) + ', ' + o.st.toUpperCase(); return { label: v, q: v, note: withStores.length ? o.n + ' nearby' : '' }; }));
      setView({ state: pick.map(function (o) { return proj2({ lat: cands[o.st][0] / 1000, lng: cands[o.st][1] / 1000 }); }), st: '' });
      setQ(q);
      track('fgo_store_search', { kind: 'choose', results: withStores.length });
    }
    function show(pt, label, q, how) {
      done();
      origin = pt;
      again = function () { reset(); show(pt, label, q, how); };
      var w = teaName() ? ' with ' + esc(teaName()) : '';
      var ranked = stores.filter(carries).map(function (s) { return { s: s, d: miles(pt.lat, pt.lng, s.lat, s.lng) }; }).sort(function (a, b) { return a.d - b.d; });
      if (!ranked.length) { total = 0; shown = []; list.innerHTML = ''; more.hidden = true; say('No store on our list carries ' + esc(teaName()) + '.', deliverBlock()); setView({ far: true, o: pt }); return; }
      var inR = ranked.filter(function (r) { return r.d <= radius; });
      var far = !inR.length && ranked[0].d > 300;
      total = inR.length;
      shown = inR.length ? inR : far ? [] : ranked.slice(0, 3);
      page = 0; list.innerHTML = '';
      var where = label === 'you' ? 'you' : esc(label);
      if (inR.length) say('<b>' + inR.length + (inR.length === 1 ? ' store' : ' stores') + '</b>' + w + ' within ' + radius + ' miles of ' + where, '');
      else if (far) say('We don’t have a Walmart' + w + ' near ' + where + ' on our list.', deliverBlock());
      else say('No stores' + w + ' within ' + radius + ' miles of ' + where + '.', 'The closest are about ' + Math.round(ranked[0].d) + ' miles away.' + deliverBlock());
      if (far) { more.hidden = true; setView({ far: true, o: pt }); } else renderPage(true);
      setQ(q);
      track('fgo_store_search', { kind: how.kind, results: inR.length, nearest_mi: Math.round(ranked[0].d), area: how.area || '', tea: tea >= 0 ? slug(ITEMS[tea]) : 'all' });
      /* phones: put the answer at the top of the screen, keyboard down */
      if (mq('(max-width: 860px)')) {
        if (mq('(hover: none)')) input.blur();
        toResult();
      }
    }
    /* scroll the answer to just under whatever stays pinned at the top (the announcement
       bar). One downward move: the theme's header hides on the way down and would come
       back on any upward correction. */
    /* what the store's sticky bars will cover once the scroll settles. Scrolling up brings the
       theme's hide-on-scroll header back, so count it even while it is slid away. */
    function barsCover(up) {
      var cover = 0;
      [].forEach.call(document.querySelectorAll('body > *, body > * > *, body > * > * > *, body > * > * > * > *'), function (e) {
        if (root.contains(e) || e.contains(root) || !e.offsetHeight || e.offsetHeight > innerHeight / 3) return;
        var cs = getComputedStyle(e); if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        var t = parseFloat(cs.top); if (isNaN(t) || t > innerHeight / 3) return;
        var r = e.getBoundingClientRect(); if (r.top > t + 1) return;          /* sticky further down the page, not stuck */
        if (up || (r.top >= t - 1 && r.bottom > 0)) cover = Math.max(cover, t + e.offsetHeight);
      });
      return cover;
    }
    function scrollToEl(el) {
      if (!el) return;
      var top = el.getBoundingClientRect().top + window.scrollY, y = top - barsCover(false) - 16;
      if (y < window.scrollY) y = top - barsCover(true) - 16;
      window.scrollTo({ top: Math.max(0, y), behavior: REDUCED ? 'auto' : 'smooth' });
      /* once it settles, check again: the header may have slid back in over the target */
      setTimeout(function () {
        var t = el.getBoundingClientRect().top, c = barsCover(false);
        if (t < c + 8) window.scrollBy({ top: t - c - 16, behavior: 'auto' });
      }, REDUCED ? 60 : 750);
    }
    function toResult() {
      var cover = 0;
      (document.elementsFromPoint ? document.elementsFromPoint(innerWidth / 2, 2) : []).some(function (el) {
        for (var e = el; e && e !== document.body && e !== document.documentElement; e = e.parentElement) {
          if (root.contains(e)) return false;
          var pos = getComputedStyle(e).position;
          if (pos === 'fixed' || pos === 'sticky') {
            var r = e.getBoundingClientRect();
            if (r.top <= 2 && r.height < innerHeight / 3) { cover = r.bottom; return true; }
            return false;
          }
        }
        return false;
      });
      var y = result.getBoundingClientRect().top + window.scrollY - cover - 12;
      if (y > window.scrollY) window.scrollTo({ top: y, behavior: REDUCED ? 'auto' : 'smooth' });
    }
    function dirUrl(s) {
      /* Stockist cut some streets and towns short: route those by coordinates */
      var cut = (s.address || '').length === 30 || (s.city || '').length === 19;
      var dest = cut ? s.lat + ',' + s.lng : 'Walmart, ' + s.address + ', ' + s.city + ', ' + s.state + ' ' + s.zip;
      return APPLE ? 'https://maps.apple.com/?daddr=' + encodeURIComponent(dest)
                   : 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(dest);
    }
    function card(r, i) {
      var s = r.s, d = mi(r.d);
      return '<li class="sf-r" data-i="' + i + '" tabindex="-1">' +
        '<span class="sf-n" aria-hidden="true">' + (i + 1) + '</span>' +
        '<div class="sf-b"><h3 class="sf-t">' + esc(s.address) + '</h3>' +
        '<p class="sf-a">Walmart · ' + esc(s.city) + ', ' + esc(s.state) + ' ' + esc(s.zip) + '</p>' +
        (teasOf(s) ? '<p class="sf-teas">' + teasOf(s) + '</p>' : '') + '</div>' +
        '<div class="sf-side"><span class="sf-d">' + d + ' <small>mi</small></span>' +
        '<a class="sf-dir" href="' + esc(dirUrl(s)) + '" target="_blank" rel="nofollow noopener" data-sf-dir>Directions<span class="sr"> to Walmart, ' +
        esc(s.address) + ', ' + esc(s.city) + ' (opens in a new tab)</span></a></div></li>';
    }
    function renderPage(first) {
      var from = page * 10, slice = shown.slice(from, from + 10);
      list.insertAdjacentHTML('beforeend', slice.map(function (r, k) { return card(r, from + k); }).join(''));
      page++;
      more.hidden = page * 10 >= shown.length;
      if (!more.hidden) more.textContent = 'Show more stores (' + (shown.length - page * 10) + ')';
      if (total > 10) sub.innerHTML = 'Showing ' + Math.min(page * 10, shown.length) + ' of ' + total + '. ' + deliver();
      else if (total) sub.innerHTML = deliver();
      setView({ rows: shown.slice(0, page * 10), o: origin, refit: first });
      if (!first) { var li = list.querySelector('.sf-r[data-i="' + from + '"]'); if (li) li.focus(); }
    }

    /* ---- list <-> map ---- */
    function rowOf(e) { var li = e.target.closest && e.target.closest('.sf-r'); return li && list.contains(li) ? li : null; }
    function lit(i, on) {
      var li = list.querySelector('.sf-r[data-i="' + i + '"]'); if (li) li.classList.toggle('is-on', on);
      var m = svg && svg.querySelector('[data-hit="' + i + '"]'); if (m) m.classList.toggle('is-on', on);
      if (gl.ready) glLit(i, on);
    }
    list.addEventListener('mouseover', function (e) { var li = rowOf(e); if (li && !li.contains(e.relatedTarget)) lit(+li.getAttribute('data-i'), true); });
    list.addEventListener('mouseout', function (e) { var li = rowOf(e); if (li && !li.contains(e.relatedTarget)) lit(+li.getAttribute('data-i'), false); });
    list.addEventListener('focusin', function (e) { var li = rowOf(e); if (li) lit(+li.getAttribute('data-i'), true); });
    list.addEventListener('focusout', function (e) { var li = rowOf(e); if (li && !li.contains(e.relatedTarget)) lit(+li.getAttribute('data-i'), false); });
    list.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a'), li = rowOf(e);
      if (a) { if (li && a.hasAttribute('data-sf-dir')) { var i = +li.getAttribute('data-i'); track('fgo_store_directions', { rank: i + 1, mi: Math.round(shown[i].d) }); } return; }
      if (li && gl.ready) glFocus(+li.getAttribute('data-i'));
    });
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a');
      if (!a) return;
      if (a.hasAttribute('data-sf-state') && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault();
        var st = a.getAttribute('data-sf-state');
        input.value = st; run(BOTH[norm(st)] ? st + ' state' : st);
        var target = mq('(max-width: 860px)') ? result : root.querySelector('.sf-grid');
        scrollToEl(target);
        setTimeout(function () { try { sum.focus({ preventScroll: true }); } catch (x) { sum.focus(); } }, 60);
        track('fgo_store_state_link', { state: st });
        return;
      }
      if (a.hasAttribute('data-sf-shop')) track('fgo_store_shop_online', {});
    });

    /* ---- the dot map: every store as a dot, drawn from its own coordinates ---- */
    var NS = 'http://www.w3.org/2000/svg', svg = null, hits = null, view = [0, 0, W, H], anim = null;
    function el(n, a) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); return e; }
    function drawMap() {
      if (svg) return;
      svg = el('svg', { viewBox: view.join(' '), preserveAspectRatio: 'xMidYMid meet', role: 'presentation', 'aria-hidden': 'true' });
      var d = '';
      stores.forEach(function (s) { var q = proj(s.lat, s.lng); s.x = q[0]; s.y = q[1]; d += 'M' + q[0].toFixed(1) + ' ' + q[1].toFixed(1) + 'h0'; });
      /* one path, round caps, strokes that do not scale: dots stay the same size when the map zooms */
      svg.appendChild(el('path', { d: d, stroke: 'currentColor', 'stroke-width': 4, 'stroke-linecap': 'round', fill: 'none', 'vector-effect': 'non-scaling-stroke', class: 'st-path', style: 'color:#046A38;opacity:.3' }));
      hits = el('g', {}); svg.appendChild(hits);
      mapBox.insertBefore(svg, mapBox.firstChild);
      if (lastV && !gl.ready) svgView(lastV);
    }
    function proj2(o) { var q = proj(o.lat, o.lng); o.x = q[0]; o.y = q[1]; return o; }
    function frame(pts, rows, o, dots) {
      var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
      pts.forEach(function (p) { x0 = Math.min(x0, p[0]); y0 = Math.min(y0, p[1]); x1 = Math.max(x1, p[0]); y1 = Math.max(y1, p[1]); });
      var w = Math.max(90, (x1 - x0) * 1.3), h = Math.max(56, (y1 - y0) * 1.3), cx = (x0 + x1) / 2, cy = (y0 + y1) / 2;
      if (w / h > W / H) h = w * H / W; else w = h * W / H;
      zoomTo([cx - w / 2, cy - h / 2, w, h], rows, o, dots);
    }
    function placeMarks(rows, o, v, dots) {
      hits.innerHTML = '';
      var u = v[2] / (mapBox.clientWidth || W);   /* view units per screen pixel */
      (dots || []).forEach(function (p) { hits.appendChild(el('circle', { class: 'on', cx: p[0], cy: p[1], r: 3.2 * u })); });
      if (o) {   /* under the store markers, so their numbers stay on top */
        hits.appendChild(el('circle', { class: 'you', cx: o.x, cy: o.y, r: 9 * u, 'stroke-width': 1.6 * u }));
        hits.appendChild(el('circle', { class: 'you-dot', cx: o.x, cy: o.y, r: 3 * u }));
      }
      var placed = [], gap = 24 * u;
      rows.forEach(function (r, k) {
        var x = r.s.x, y = r.s.y;
        for (var pass = 0; pass < 3; pass++) {
          placed.forEach(function (p) {
            var dx = x - p[0], dy = y - p[1], d = Math.sqrt(dx * dx + dy * dy);
            if (d < gap) { if (d < 1e-6) { dx = 0.8; dy = -0.6; d = 1; } x = p[0] + dx / d * gap; y = p[1] + dy / d * gap; }
          });
        }
        placed.push([x, y]);
        var g = el('g', { 'data-hit': k });
        if (x !== r.s.x || y !== r.s.y) g.appendChild(el('line', { class: 'hit-leg', x1: r.s.x, y1: r.s.y, x2: x, y2: y, 'stroke-width': 1.2 * u }));
        g.appendChild(el('circle', { class: 'hit', cx: x, cy: y, r: 11 * u }));
        var t = el('text', { class: 'hit-n', x: x, y: y, style: 'font-size:' + (11 * u) + 'px' }); t.textContent = k + 1; g.appendChild(t);
        hits.appendChild(g);
      });
    }
    function zoomTo(target, rows, o, dots) {
      if (anim) cancelAnimationFrame(anim);
      var from = view.slice(), t0 = null, dur = REDUCED ? 0 : 650;
      var ease = function (k) { return 1 - Math.pow(1 - k, 3); };
      var step = function (t) {
        if (t0 === null) t0 = t;
        var k = dur ? Math.min(1, (t - t0) / dur) : 1, e = ease(k);
        view = from.map(function (f, i) { return f + (target[i] - f) * e; });
        svg.setAttribute('viewBox', view.join(' '));
        if (rows) placeMarks(rows, o, view, dots); else hits.innerHTML = '';
        if (k < 1) anim = requestAnimationFrame(step); else anim = null;
      };
      anim = requestAnimationFrame(step);
    }
    function svgView(v) {
      if (!svg) return;
      var rows = v.rows || [], top = rows.slice(0, 10), rest = rows.slice(10).map(function (r) { return [r.s.x, r.s.y]; });
      if (v.o) proj2(v.o);
      if (v.state) { var pts = v.state.map(function (s) { return [s.x, s.y]; }); return frame(pts, [], null, pts); }
      if (v.far) return zoomTo([0, 0, W, H], [], v.o);
      if (v.keep) { if (anim) cancelAnimationFrame(anim); hits.innerHTML = ''; return; }
      if (v.refit === false) return placeMarks(top, v.o, view, rest);
      var box = top.map(function (r) { return [r.s.x, r.s.y]; }); if (v.o) box.push([v.o.x, v.o.y]);
      if (!box.length) return zoomTo([0, 0, W, H]);
      frame(box, top, v.o || null, rest);
    }
    function setView(v) { lastV = v; if (gl.ready) glView(v, false); else svgView(v); }

    /* ---- the street map: MapLibre GL on OpenStreetMap data (ODbL; credited on the map with
       a link to openstreetmap.org/copyright). Two free, keyless tile services in turn:
       OpenFreeMap, then VersaTiles. If neither draws within 12 seconds, or WebGL or the
       library is missing, the dot map carries on. Starts when the map comes into view or
       on the first search. ---- */
    var GL = { js: 'https://cdn.jsdelivr.net/npm/maplibre-gl@5.24.0/dist/maplibre-gl.js', jsSri: 'sha384-5+cfbwT0iiub6VsQAdn6yz16nr6sDiQoHx6tm4O8OVYXHYOxcffFmCJBL0dgdvGp',
               css: 'https://cdn.jsdelivr.net/npm/maplibre-gl@5.24.0/dist/maplibre-gl.css', cssSri: 'sha384-uTttxo/aOKbdE5RlD/SPzSDoDmNvGlUYPjONi2MN/b7c9HPSvW07OIuyP7uL6jxK' };
    /* the FGO palette both styles are re-inked in: cream land, sage parks, soft sea-green water */
    var C = { land: '#F2EEE1', water: '#C9DAD4', park: '#DEE5CF', wood: '#E2E7D3', res: '#EDE9DC', bldg: '#E4DECF',
              road: '#FFFFFF', edge: '#E0D8C7', minor: '#FAF7EF', rail: '#D9D2C2', border: '#B3AA97', label: '#5B574D', place: '#34322C', halo: '#F5F3E7' };
    function inkLabel(l, place) {
      var p = l.paint = l.paint || {};
      p['text-color'] = place ? C.place : C.label; p['text-halo-color'] = C.halo; p['text-halo-width'] = 1.4;
    }
    var STYLES = [
      { name: 'openfreemap', url: 'https://tiles.openfreemap.org/styles/positron', tint: function (style) {
        style.layers.forEach(function (l) {
          var id = l.id, p = l.paint = l.paint || {};
          if (l.type === 'background') p['background-color'] = C.land;
          else if (id === 'water') p['fill-color'] = C.water;
          else if (id === 'waterway') p['line-color'] = C.water;
          else if (id === 'park') { p['fill-color'] = C.park; p['fill-opacity'] = 0.75; }
          else if (id === 'landcover_wood') p['fill-color'] = C.wood;
          else if (id === 'landuse_residential') p['fill-color'] = C.res;
          else if (id === 'building') p['fill-color'] = C.bldg;
          else if (l.type === 'line' && /casing/.test(id)) p['line-color'] = C.edge;
          else if (l.type === 'line' && /^highway_(major|motorway)|bridge_inner/.test(id)) p['line-color'] = C.road;
          else if (l.type === 'line' && /^highway_(minor|path)|road_pier/.test(id)) p['line-color'] = C.minor;
          else if (l.type === 'line' && /^railway/.test(id)) p['line-color'] = C.rail;
          else if (l.type === 'line' && /^boundary/.test(id)) p['line-color'] = C.border;
          else if (l.type === 'symbol' && l.layout && l.layout['text-field'] && !/shield/.test(id)) inkLabel(l, /^label_(city|state|country|town)/.test(id));
        });
        return style;
      } },
      { name: 'versatiles', url: 'https://tiles.versatiles.org/assets/styles/muted/style.json', tint: function (style) {
        style.layers.forEach(function (l) {
          var id = l.id, p = l.paint = l.paint || {};
          if (id === 'background') p['background-color'] = C.land;
          else if (l.type === 'fill' && /^water/.test(id)) p['fill-color'] = C.water;
          else if (l.type === 'line' && /^water/.test(id)) p['line-color'] = C.water;
          else if (l.type === 'fill' && /^land-(park|garden|grass|forest|wood)/.test(id)) p['fill-color'] = C.park;
          else if (l.type === 'fill' && id === 'land-residential') p['fill-color'] = C.res;
          else if (l.type === 'line' && /^boundary/.test(id)) p['line-color'] = C.border;
          else if (l.type === 'symbol' && l.layout && l.layout['text-field'] && !/shield|housenumber/.test(id)) inkLabel(l, /^label-place/.test(id));
        });
        return style;
      } }
    ];
    var US = [[-125, 24.3], [-66.9, 49.4]];
    var gl = { started: false, ready: false, map: null, pins: [], temp: null, source: '' };
    function hasWebGL() {
      try {
        var c = document.createElement('canvas'), x = c.getContext('webgl2') || c.getContext('webgl');
        if (!x) return false;
        var lose = x.getExtension('WEBGL_lose_context'); if (lose) lose.loseContext();
        return true;
      } catch (e) { return false; }
    }
    function loadLib() {
      if (window.maplibregl) return Promise.resolve(window.maplibregl);
      if (window.__fgoGL) return window.__fgoGL;
      return (window.__fgoGL = new Promise(function (ok, no) {
        var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = GL.css; l.integrity = GL.cssSri; l.crossOrigin = 'anonymous'; document.head.appendChild(l);
        var s = document.createElement('script'); s.src = GL.js; s.integrity = GL.jsSri; s.crossOrigin = 'anonymous'; s.async = true;
        s.onload = function () { if (window.maplibregl) ok(window.maplibregl); else no(new Error('no maplibregl')); };
        s.onerror = no; document.head.appendChild(s);
      }));
    }
    var fc = function (pts) { return { type: 'FeatureCollection', features: pts.map(function (p) { return { type: 'Feature', properties: {}, geometry: { type: 'Point', coordinates: p } }; }) }; };
    function startGL() {
      if (gl.started || root.getAttribute('data-sf-gl') === 'false') return;
      gl.started = true;
      if (!hasWebGL()) return;
      STYLES[0].pre = getJSON(STYLES[0].url); STYLES[0].pre.catch(function () {});
      Promise.all([loadLib(), loadStores()]).then(function (r) { tryStyle(r[0], 0); }).catch(function () {});
    }
    /* credits are links to other sites: not endorsements */
    function relAttrib() {
      [].forEach.call(mapBox.querySelectorAll('.maplibregl-ctrl-attrib a'), function (a) { a.setAttribute('rel', 'nofollow noopener'); });
    }
    function tryStyle(ml, n) {
      if (gl.ready || n >= STYLES.length) return;
      var st = STYLES[n], box = document.createElement('div'), errs = 0, map = null, done = false;
      box.className = 'sf-gl'; box.setAttribute('inert', '');
      var t = setTimeout(next, 12000);
      function next() {
        if (gl.ready || done) return;
        done = true; clearTimeout(t);
        try { if (map) map.remove(); } catch (e) {}
        gl.map = null;
        if (box.parentNode) box.parentNode.removeChild(box);
        tryStyle(ml, n + 1);
      }
      (st.pre || getJSON(st.url)).then(function (raw) {
        if (done || gl.ready) return;
        var style = st.tint(raw), first = null;
        /* narrow maps: the short form of the same credits on one line (OpenStreetMap still links
           to its copyright page; OpenFreeMap's own name is optional under its terms) */
        if (st.name === 'openfreemap' && mapBox.clientWidth < 480 && style.sources && style.sources.openmaptiles) {
          style.sources.openmaptiles.attribution = '<a href="https://www.openmaptiles.org/" target="_blank">&copy; OpenMapTiles</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap</a>';
        }
        style.layers.some(function (l) { if (l.type === 'symbol') { first = l.id; return true; } return false; });
        mapBox.appendChild(box);
        map = gl.map = new ml.Map({
          container: box, style: style, bounds: US, fitBoundsOptions: { padding: 20 }, attributionControl: false,
          cooperativeGestures: mq('(pointer: coarse)'), dragRotate: false, pitchWithRotate: false, touchPitch: false, maxPitch: 0,
          renderWorldCopies: false, fadeDuration: 150
        });
        map.touchZoomRotate.disableRotation();
        if (map.keyboard && map.keyboard.disableRotation) map.keyboard.disableRotation();
        map.addControl(new ml.NavigationControl({ showCompass: false }), 'top-right');
        map.addControl(new ml.AttributionControl({ compact: true }), 'bottom-right');
        /* a service that is up but failing its tiles: move on before the shopper waits 12s */
        map.on('error', function () { if (!gl.ready && ++errs >= 4) next(); });
        map.on('load', function () {
          if (done || gl.map !== map) return;
          map.addSource('sf', { type: 'geojson', data: { type: 'FeatureCollection', features: stores.map(function (s) {
            return { type: 'Feature', properties: { st: s.state.toLowerCase(), town: s.city + ', ' + s.state }, geometry: { type: 'Point', coordinates: [s.lng, s.lat] } };
          }) } });
          map.addSource('sf-hit', { type: 'geojson', data: fc([]) });
          map.addSource('sf-origin', { type: 'geojson', data: fc([]) });
          map.addLayer({ id: 'sf-all', type: 'circle', source: 'sf', paint: {
            'circle-color': '#046A38', 'circle-opacity': 0.5,
            'circle-radius': ['interpolate', ['linear'], ['zoom'], 3, 2, 7, 3.5, 12, 5.5],
            'circle-stroke-color': '#F5F3E7', 'circle-stroke-width': ['interpolate', ['linear'], ['zoom'], 4, 0, 8, 1]
          } }, first);
          map.addLayer({ id: 'sf-state', type: 'circle', source: 'sf', filter: ['==', ['get', 'st'], ''], paint: {
            'circle-color': '#023A1F', 'circle-radius': ['interpolate', ['linear'], ['zoom'], 4, 3.4, 9, 6],
            'circle-stroke-color': '#F5F3E7', 'circle-stroke-width': 1.2
          } }, first);
          /* results past the first ten: dark dots, numbered only while their card is hovered */
          map.addLayer({ id: 'sf-hit', type: 'circle', source: 'sf-hit', paint: {
            'circle-color': '#023A1F', 'circle-radius': 5, 'circle-stroke-color': '#F5F3E7', 'circle-stroke-width': 1.5
          } }, first);
          /* the searched place sits under the map's labels, so its own name stays readable */
          map.addLayer({ id: 'sf-origin-halo', type: 'circle', source: 'sf-origin', paint: {
            'circle-radius': 13, 'circle-color': 'rgba(20,20,20,0.10)', 'circle-stroke-color': '#141414', 'circle-stroke-width': 2
          } }, first);
          map.addLayer({ id: 'sf-origin', type: 'circle', source: 'sf-origin', paint: { 'circle-radius': 4, 'circle-color': '#141414' } }, first);
          map.on('move', nudge);
          var dotAt = function (pt) { return shown.length ? null : map.queryRenderedFeatures(pt, { layers: ['sf-state', 'sf-all'] })[0]; };
          map.on('click', function (e) {
            var t = e.originalEvent && e.originalEvent.target;
            if (t && t.closest && t.closest('.maplibregl-marker')) return;
            var f = dotAt(e.point); if (!f) return;
            var q = f.properties.town; input.value = q; run(q); track('fgo_store_map_dot', {});
          });
          map.on('mousemove', function (e) { map.getCanvas().style.cursor = dotAt(e.point) ? 'pointer' : ''; });
          clearTimeout(t);
          gl.ready = true; gl.source = st.name;
          box.removeAttribute('inert');
          mapBox.classList.add('is-gl'); mapBox.setAttribute('data-sf-tiles', st.name);
          mapBox.removeAttribute('aria-hidden'); mapBox.setAttribute('role', 'region'); mapBox.setAttribute('aria-label', 'Map of stores');
          relAttrib(); setTimeout(relAttrib, 1500);
          if (lastV) { var v = {}; for (var k in lastV) v[k] = lastV[k]; if (v.refit === false) v.refit = true; glView(v, true); }
        });
      }).catch(next);
    }
    function pinEl(n) {
      var e = document.createElement('div'); e.className = 'sf-pin';
      /* MapLibre only fills role/aria-label when missing; the list already says all this */
      e.setAttribute('aria-hidden', 'true'); e.setAttribute('role', 'presentation');
      e.innerHTML = '<i class="sf-tail"></i><span>' + n + '</span>';
      return e;
    }
    function clearPins() {
      gl.pins.forEach(function (m) { m.remove(); }); gl.pins = [];
      if (gl.temp) { gl.temp.remove(); gl.temp = null; }
    }
    function setGeo(id, pts) { var s = gl.map.getSource(id); if (s) s.setData(fc(pts)); }
    function fit(pts, dur, maxZoom) {
      var ml = window.maplibregl, b = new ml.LngLatBounds(pts[0], pts[0]);
      pts.forEach(function (p) { b.extend(p); });
      var small = mapBox.clientWidth < 520;
      gl.map.fitBounds(b, { padding: small ? { top: 40, right: 52, bottom: 68, left: 32 } : { top: 56, right: 64, bottom: 60, left: 48 }, duration: dur, maxZoom: maxZoom });
    }
    function glView(v, instant) {
      var map = gl.map, ml = window.maplibregl, dur = (instant || REDUCED) ? 0 : 900;
      var rows = v.rows || [], top = rows.slice(0, 10);
      clearPins();
      map.setFilter('sf-state', ['==', ['get', 'st'], v.st || '']);
      setGeo('sf-origin', v.o ? [[v.o.lng, v.o.lat]] : []);
      setGeo('sf-hit', rows.slice(10).map(function (r) { return [r.s.lng, r.s.lat]; }));
      if (v.state) return fit(v.state.map(function (s) { return [s.lng, s.lat]; }), dur, 9);
      if (v.far) return map.easeTo({ center: [v.o.lng, v.o.lat], zoom: 6, duration: dur });
      if (v.keep) return;
      top.forEach(function (r, k) {
        var e = pinEl(k + 1);
        e.style.zIndex = String(200 - k);          /* 1 on top of 2, 2 on top of 3 ... */
        e.addEventListener('mouseenter', function () { lit(k, true); });
        e.addEventListener('mouseleave', function () { lit(k, false); });
        e.addEventListener('click', function () {
          var li = list.querySelector('.sf-r[data-i="' + k + '"]'); if (!li) return;
          li.scrollIntoView({ block: 'nearest', behavior: REDUCED ? 'auto' : 'smooth' });
          li.classList.add('is-on'); setTimeout(function () { li.classList.remove('is-on'); }, 1400);
        });
        gl.pins[k] = new ml.Marker({ element: e }).setLngLat([r.s.lng, r.s.lat]).addTo(map);
      });
      if (v.refit === false) { nudge(); return; }
      var pts = top.map(function (r) { return [r.s.lng, r.s.lat]; });
      if (v.o) pts.push([v.o.lng, v.o.lat]);
      if (!pts.length) return map.fitBounds(US, { padding: 20, duration: dur });
      fit(pts, dur, 12.5);
      nudge();
    }
    function glLit(i, on) {
      if (i < 10) { var p = gl.pins[i]; if (p) p.getElement().classList.toggle('is-on', on); return; }
      if (gl.temp) { gl.temp.remove(); gl.temp = null; }
      if (!on || !shown[i]) return;
      var e = pinEl(i + 1); e.classList.add('is-on'); e.style.zIndex = '300';
      gl.temp = new window.maplibregl.Marker({ element: e }).setLngLat([shown[i].s.lng, shown[i].s.lat]).addTo(gl.map);
    }
    /* a card tapped: bring its store into view if it is off the map, and pulse its pin */
    function glFocus(i) {
      var r = shown[i]; if (!r) return;
      if (!gl.map.getBounds().contains([r.s.lng, r.s.lat])) gl.map.easeTo({ center: [r.s.lng, r.s.lat], duration: REDUCED ? 0 : 600 });
      glLit(i, true);
      var pe = i < 10 ? gl.pins[i] && gl.pins[i].getElement() : gl.temp && gl.temp.getElement();
      if (pe) { pe.classList.remove('is-pulse'); void pe.offsetWidth; pe.classList.add('is-pulse'); }
    }
    /* two stores in one town share a spot at wide zooms: nudge later pins 26px clear and
       draw a short tail back to the store */
    function nudge() {
      if (!gl.pins.length) return;
      var placed = [], gap = 26;
      gl.pins.forEach(function (m) {
        var p = gl.map.project(m.getLngLat()), x = p.x, y = p.y;
        for (var pass = 0; pass < 3; pass++) placed.forEach(function (q) {
          var dx = x - q[0], dy = y - q[1], d = Math.sqrt(dx * dx + dy * dy);
          if (d < gap) { if (d < 1e-6) { dx = 0.8; dy = -0.6; d = 1; } x = q[0] + dx / d * gap; y = q[1] + dy / d * gap; }
        });
        placed.push([x, y]);
        var ox = x - p.x, oy = y - p.y, len = Math.sqrt(ox * ox + oy * oy), tail = m.getElement().firstChild;
        m.setOffset([ox, oy]);
        if (tail) { tail.style.width = len > 2 ? len + 'px' : '0'; tail.style.transform = 'rotate(' + Math.atan2(-oy, -ox) + 'rad)'; }
      });
    }

    /* ---- wiring ---- */
    form.addEventListener('submit', function (e) { e.preventDefault(); run(input.value); });
    more.addEventListener('click', function () { renderPage(false); });
    /* start downloading the one table a search will need while the shopper types */
    input.addEventListener('input', function () {
      var v = norm(input.value); if (!v) return;
      loadStores().catch(function () {});
      if (/^\d{1,5}$/.test(v)) shard('zips', v.charAt(0)).catch(function () {});
      else if (/^[a-z]/.test(v)) shard('places', letter(v)).catch(function () {});
    });
    near.addEventListener('click', function () {
      var my = ++seq;
      reset();
      if (!navigator.geolocation) { say('Your browser can’t share your location.', 'Type a ZIP code or city instead.'); return; }
      startGL();
      say('Finding your location&hellip;'); result.setAttribute('aria-busy', 'true');
      navigator.geolocation.getCurrentPosition(function (pos) {
        loadStores().then(function () {
          if (my !== seq) return;
          input.value = ''; show({ lat: pos.coords.latitude, lng: pos.coords.longitude }, 'you', null, { kind: 'geo' });
        }).catch(function () { fail(my); });
      }, function (err) {
        if (my !== seq) return;
        done();
        say(err && err.code === 1 ? 'Location is off for this site.' : 'We couldn’t get your location.', 'Type a ZIP code or city instead.');
      }, { timeout: 10000, maximumAge: 600000 });
    });
    /* desktop: the map runs from the top of the section to just above the bottom of the
       screen, so it is whole on arrival and stays whole once it sticks while the list scrolls */
    function sizeMap() {
      if (mq('(max-width: 860px)')) { mapBox.style.removeProperty('--sf-map-h'); return; }
      var top = mapBox.getBoundingClientRect().top + window.scrollY;
      var h = Math.max(440, Math.min(780, window.innerHeight - Math.min(top, window.innerHeight) - 24));
      mapBox.style.setProperty('--sf-map-h', Math.round(h) + 'px');
    }
    sizeMap();
    var rz = null; addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(sizeMap, 150); });
    /* the street map (~1.3 MB of library and map images) loads on desktop once the map is
       (nearly) on screen. On phones, and whenever the browser asks to save data, it waits for
       the first search: browsing shoppers get the light dot map and download none of it. */
    var lean = mq('(max-width: 860px)') || !!(navigator.connection && navigator.connection.saveData);
    if (!lean) {
      ['https://tiles.openfreemap.org', 'https://cdn.jsdelivr.net'].forEach(function (h) {
        var l = document.createElement('link'); l.rel = 'preconnect'; l.href = h; l.crossOrigin = ''; document.head.appendChild(l);
      });
      startGL();
    } else if (!(navigator.connection && navigator.connection.saveData)) {
      input.addEventListener('focus', startGL, { once: true });
    }
    /* phones: a way back to the search box after the answer has scrolled it away */
    /* the questions: one open at a time, like the homepage FAQ */
    var acc = $('[data-sf-acc]');
    if (acc) {
      var rows = [].slice.call(acc.querySelectorAll('[data-sf-row]'));
      rows.forEach(function (r) {
        var b = r.querySelector('.sf-q');
        b.addEventListener('click', function () {
          var was = r.classList.contains('sf-open');
          rows.forEach(function (o) { o.classList.remove('sf-open'); o.querySelector('.sf-q').setAttribute('aria-expanded', 'false'); });
          if (!was) { r.classList.add('sf-open'); b.setAttribute('aria-expanded', 'true'); track('fgo_store_faq', { q: rows.indexOf(r) + 1 }); }
        });
      });
      acc.classList.add('is-ready');
    }
    var change = $('[data-sf-change]');
    if (change) change.addEventListener('click', function () { scrollToEl(form); try { input.focus({ preventScroll: true }); input.select(); } catch (x) { input.focus(); } });
    loadStores().catch(function () {});
    /* ?find= (Shopify keeps ?q= in the canonical address, so the page never writes it; old ?q= links still work) */
    var q0 = null; try { var sp = new URL(location.href).searchParams; q0 = sp.get('find') || sp.get('q'); } catch (e) {}
    if (q0) { input.value = q0; run(q0); }
  }
  var start = function () { [].forEach.call(document.querySelectorAll('.fgoSF'), function (r) { if (!r.__sf) { r.__sf = 1; init(r); } }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
}());
